import { HttpConstants } from '../protocols/http/http-constants';
import { HttpGetClient } from '../protocols/http/http-get-client';
import { FetchUserRoles } from '../../domain/useages/fetch-user-roles';

export class RemoteFetchUserRoles implements FetchUserRoles {
    constructor(
        private readonly ulr: string,
        private readonly httpGetClient: HttpGetClient
    ) { }
    async fetch(params?: FetchUserRoles.Params): Promise<any>{
        const httpResponse = await this.httpGetClient.get({
            url: this.ulr,
            query: params,
            headers: {
                [HttpConstants.CONTENT_TYPE]: HttpConstants.APPLICATION_JSON,
                [HttpConstants.ACCEPT]: HttpConstants.APPLICATION_JSON,
                 [HttpConstants.APP_ID]: HttpConstants.APP_ID_VALUE,
            },
            authHeaders:true,
            
        })
        if (httpResponse.status === 200) {
            return httpResponse.data;
        }
    }
}
